import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Headers from './Header';
import NavigationBar from './Navigation';
import Loader from '../common/Loader';
import AddNotes from '../common/AddNotes';
import Pagination from '../common/Pagination';
import { PATH } from '../../../utils/Constants';
// import profileImg from "../../../utils/images/profileImg.png";
import store from '../../../sessionStorage';
import SessionStatusButton from '../common/SessionStatusButton';
import {
    getAddNotesList,
    getStudentHistory,
    submitAddNotes,
} from '../../action/educator/AppointmentAction';
import { showNotification } from '../../action/NotificationAction';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import { getStudent, getUserById } from '../../action/Admin/CommonAction';
import AppConfig from '../../../utils/common/DomainConfiguration';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

const withLanguage = (Component) => {
    return (props) => (
        <LanguageContext.Consumer>
            {({ t, language }) => <Component {...props} t={t} language={language} />}
        </LanguageContext.Consumer>
    );
};

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class StudentSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            studentDetail: {},
            studentHistoryLoading: false,
            submitBtnLoading: false,
            addNotesLoading: false,
            isAddNotesModalOpen: false,
            totalPages: 0,
            currentPage: 1,
            addNotesCurrentPage: 1,
            addNotestotalPages: 0,
            studentHistory: [],
            addNotesHistory: [],
            userId: '',
            isTabChange: 'studentHistory',
            isLoading: false,
            studentUserId: this.props.match.params.studentId,
            materialUploadedImages: [],
            totalUploadedSize: 0,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleAddNotesPageChange = this.handleAddNotesPageChange.bind(this);
    }

    //componentDidMount
    componentDidMount() {
        this.getStudent();
        this.getStudentViewHistory(1, 5);
    }

    //isTabChange
    isTabChange = () => {
        if (this.state.isTabChange === 'studentHistory') {
            this.getAddNotesHistory(1, 5);
        } else {
            this.getStudentViewHistory(1, 5);
        }
    };

    //handlePageChange
    handlePageChange(event) {
        this.setState(
            {
                currentPage: Number(event.selected),
                studentHistoryLoading: true,
                offSetValue: Number(event.selected) * 5,
            },
            this.getStudentViewHistory(Number(event.selected) + 1, 5)
        );
    }

    //handleAddNotesPageChange
    handleAddNotesPageChange(event) {
        this.setState(
            {
                addNotesCurrentPage: Number(event.selected),
                studentHistoryLoading: true,
                offSetValue: Number(event.selected) * 5,
            },
            this.getAddNotesHistory(Number(event.selected) + 1, 5)
        );
    }

    //getStudent
    getStudent() {
        this.setState({ isLoading: true });
        this.props.getStudent(this.state.studentUserId, (result) => {
            if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({ studentDetail: result.response });
                this.setState({ isLoading: false });
                this.setState({
                    studentId: result.response.student?.id || result.response.id,
                });
            } else {
                this.setState({ isLoading: false });
                this.props.showNotification(result.message, RESPONSE_CONSTANT.ERROR);
            }
        });
    }

    //getStudentViewHistory
    getStudentViewHistory(pageNumber, itemsPerPage) {
        const values = {
            pageNumber,
            itemsPerPage,
        };
        this.props.getStudentHistory(
            store.get('userSession').tutor.id,
            this.state.studentUserId,
            values,
            (response) => {
                this.setState({ studentHistoryLoading: false });
                if (response) {
                    if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.setState({
                            studentHistory: response.response.data,
                            currentPage: response.response.currentPage,
                            totalPages: response.response.totalPages,
                        });
                    } else {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                    }
                }
            }
        );
    }

    //notesSubmit
    notesSubmitBtn = () => {
        const { notesSummary } = this.state;
        let values = {
            id: this.state.studentUserId,
            notes: notesSummary,
            materialImages: this.state.materialUploadedImages,
        };
        if (!values.notes) {
            this.props.showNotification(
                RESPONSE_CONSTANT.CANCELATION_REASON_EMPTY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        this.setState({ submitBtnLoading: true });
        this.props.submitAddNotes(values, (response) => {
            this.setState({ submitBtnLoading: false });
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                this.setState({ notesSummary: '', materialUploadedImages: null });
                this.getAddNotesHistory(1, 5);
                this.closeAddNotesModal();
            } else {
                if (response.message) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                }
            }
        });
    };

    //getAddNotesHistory
    getAddNotesHistory(pageNumber, itemsPerPage) {
        const values = {
            pageNumber,
            itemsPerPage,
        };
        this.props.getAddNotesList(this.state.studentUserId, values, (response) => {
            if (response) {
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.setState({
                        addNotesLoading: false,
                        addNotesHistory: response.response.data,
                        addNotesCurrentPage: response.response.pageNumber,
                        addNotestotalPages: response.response.totalPages,
                    });
                }
            }
        });
    }

    //onClick
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    //openAddNotesModal
    openAddNotesModal = () => {
        this.setState({ isAddNotesModalOpen: true });
    };

    //closeAddNotesModal
    closeAddNotesModal = () => {
        this.setState({ isAddNotesModalOpen: false, materialUploadedImages: null });
    };

    //handleFileUpload
    handleFileUpload = (event) => {
        const files = event.target.files;
        let { totalUploadedSize, materialUploadedImages } = this.state;
        let newUploadSize = 0;
        const MAX_TOTAL_SIZE = 52428800;
        const MAX_SINGLE_FILE_SIZE = 10485760;
        const validFiles = [];
        const readerPromises = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (
                (file.type === 'image/png' ||
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'application/pdf') &&
                file.size <= MAX_SINGLE_FILE_SIZE
            ) {
                newUploadSize += file.size;
                if (totalUploadedSize + newUploadSize > MAX_TOTAL_SIZE) {
                    this.props.showNotification(
                        RESPONSE_CONSTANT.MEDIA_TOTAL_SIZE_EXCEEDED,
                        RESPONSE_CONSTANT.WARNING
                    );
                    return;
                }
                validFiles.push(file);
            } else if (file.size > MAX_SINGLE_FILE_SIZE) {
                this.props.showNotification(
                    RESPONSE_CONSTANT.MEDIA_FILE_SIZE,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            } else {
                this.props.showNotification(
                    RESPONSE_CONSTANT.UPLOAD_ONLY_IMAGE,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
        }

        validFiles.forEach((file) => {
            const reader = new FileReader();
            readerPromises.push(
                new Promise((resolve) => {
                    reader.onloadend = () => resolve({ result: reader.result, size: file.size });
                    reader.readAsDataURL(file);
                })
            );
        });

        Promise.all(readerPromises).then((base64Results) => {
            const newTotalSize = totalUploadedSize + newUploadSize;
            this.setState({
                materialUploadedImages: [
                    ...materialUploadedImages,
                    ...base64Results.map((res) => res.result),
                ],
                totalUploadedSize: newTotalSize,
            });
        });
    };

    removeImage = (indexToRemove) => {
        const { materialUploadedImages, totalUploadedSize } = this.state;
        const removedFile = materialUploadedImages[indexToRemove];
        const newImages = materialUploadedImages.filter((_, index) => index !== indexToRemove);
        const newTotalSize = totalUploadedSize - removedFile.size;
        this.setState({
            materialUploadedImages: newImages,
            totalUploadedSize: newTotalSize,
        });
    };

    /**
     * Render page
     */
    render() {
        return (
            <>
                <div className="fixed top-0 left-0 flex w-full h-full">
                    <div
                        className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                            this.state.mobileNav ? 'block' : 'hidden'
                        }`}
                    ></div>
                    <NavigationBar
                        nav={true}
                        {...this.props}
                        active={PATH.IM_PHYSICIAN.MY_STUDENTS}
                        mobileNav={this.state.mobileNav}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <main className="flex flex-col flex-grow overflow-auto">
                        <Headers
                            {...this.props}
                            title={this.props.t('memberSummary')}
                            onClickMobileNav={this.onClickMobileNav}
                        />
                        <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                            <div className="items-center justify-between px-4 sm:flex sm:px-8">
                                <h6 className="m-0 text-lg font-semibold text-white">
                                    {this.props.t('memberSummary')}
                                </h6>
                            </div>
                            {this.state.isLoading ? (
                                <Loader />
                            ) : (
                                <div className="flex flex-col gap-8 px-4 pt-6 sm:px-8">
                                    <div className="flex flex-row items-center w-full p-6 rounded-lg bg-card">
                                        <div className="justify-between w-full sm:flex gap-x-6">
                                            <div className="flex flex-col items-center mb-5 gap-x-4 sm:mb-0 sm:flex-row">
                                                {/* <img
                          className="flex-none rounded-full sm:w-16 sm:h-16 w-9 h-9 bg-gray-50"
                          src={
                            this.state.studentDetail?.image
                              ? this.state.studentDetail?.image
                              : profileImg
                          }
                          alt=""
                        /> */}
                                                <div>
                                                    <div className="flex flex-col mt-2 sm:flex-row">
                                                        <p className="font-semibold text-white sm:pb-4 whitespace-nowrap">
                                                            {this.props.t('memberName')} :
                                                            &nbsp;{' '}
                                                        </p>
                                                        <span
                                                            className="font-normal text-UIsecondary"
                                                            title={this.state.studentDetail?.name}
                                                        >
                                                            {this.state.studentDetail?.name &&
                                                            this.state.studentDetail.name.length >
                                                                25
                                                                ? `${this.state.studentDetail.name.slice(
                                                                      0,
                                                                      25
                                                                  )}...`
                                                                : this.state.studentDetail?.name}
                                                        </span>
                                                    </div>
                                                    {/* <div className="flex flex-col mt-2 sm:flex-row">
                            <p className="font-semibold text-white sm:pb-4 whitespace-nowrap">
                              Institution Name : &nbsp;{" "}
                            </p>
                            <span
                              className="font-normal break-all text-UIsecondary"
                              title={this.state.studentDetail.levelThree?.name}
                            >
                              {this.state.studentDetail.levelThree?.name &&
                              this.state.studentDetail.levelThree.name.length >
                                25
                                ? `${this.state.studentDetail.levelThree.name.slice(
                                    0,
                                    25
                                  )}...`
                                : this.state.studentDetail.levelThree?.name}
                            </span>
                          </div> */}
                                                </div>
                                            </div>
                                            <div className="flex items-center justify-center mb-5 sm:mb-0">
                                                <button
                                                    className={`bg-UIprimary py-2 px-3 rounded-lg text-white text-sm whitespace-nowrap h-fit flex items-center justify-center gap-2${
                                                        !this.state.studentDetail.active
                                                            ? 'disabled-button'
                                                            : ''
                                                    }`}
                                                    disabled={!this.state.studentDetail.active}
                                                    onClick={() => {
                                                        this.props.history.push(
                                                            `${PATH.IM_PHYSICIAN.APPOINTMENT}/${
                                                                this.props.match.params.userId
                                                            }/create?studentId=${
                                                                this.state.studentDetail.student
                                                                    ?.id ||
                                                                this.state.studentDetail.tutor?.id
                                                            }&name=${this.state.studentDetail.name}&levelId=${
                                                                this.state?.studentDetail
                                                                    ?.associatedLevels &&
                                                                this.state?.studentDetail
                                                                    ?.associatedLevels[0]?.id
                                                            }&associatename=${
                                                                this.state?.studentDetail
                                                                    ?.associatedLevels &&
                                                                this.state?.studentDetail
                                                                    ?.associatedLevels[0]?.name
                                                            }&studentUserId=${
                                                                this.state.studentUserId
                                                            }&role=${this.state.studentDetail.role}`
                                                        );
                                                    }}
                                                >
                                                    <svg
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 18 18"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M6 1.5V3.75"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M12 1.5V3.75"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M2.625 6.81738H15.375"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M15.75 6.375V12.75C15.75 15 14.625 16.5 12 16.5H6C3.375 16.5 2.25 15 2.25 12.75V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375Z"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeMiterlimit="10"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M8.99661 10.2754H9.00335"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M6.22073 10.2754H6.22747"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M6.22073 12.5254H6.22747"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>{' '}
                                                    {this.props.t('createASession')}
                                                </button>
                                                <div style={{ width: '10px' }}></div>
                                                <button
                                                    className="flex items-center justify-center gap-2 px-3 py-2 text-sm text-white bg-black rounded-lg whitespace-nowrap h-fit"
                                                    onClick={this.openAddNotesModal}
                                                >
                                                    <svg
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 18 18"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M16.5 7.5V11.25C16.5 15 15 16.5 11.25 16.5H6.75C3 16.5 1.5 15 1.5 11.25V6.75C1.5 3 3 1.5 6.75 1.5H10.5"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M16.5 7.5H13.5C11.25 7.5 10.5 6.75 10.5 4.5V1.5L16.5 7.5Z"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                    {this.props.t('addNotes')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <>
                                        <div className="flex flex-row flex-grow mt-6">
                                            <div className="flex flex-col w-full p-6 rounded-lg bg-card">
                                                <nav className="flex flex-col sm:flex-row gap-4 mb-6  border-b border-[#34373E]">
                                                    <button
                                                        className={
                                                            this.state.isTabChange ===
                                                            'studentHistory'
                                                                ? 'text-UIprimary font-medium text-base px-3 block hover:text-UIprimary focus:outline-none border-b-2 pb-2'
                                                                : 'text-UIsecondary text-base font-normal px-3 block focus:outline-none pb-2'
                                                        }
                                                        onClick={() => {
                                                            this.setState({
                                                                isTabChange: 'studentHistory',
                                                            });
                                                            this.isTabChange();
                                                        }}
                                                    >
                                                        {this.props.t('viewMemberHistory')}
                                                    </button>
                                                    <button
                                                        className={
                                                            this.state.isTabChange === 'notes'
                                                                ? 'text-UIprimary font-medium text-base px-3 block hover:UIprimary focus:outline-none border-b-2 pb-2'
                                                                : 'text-UIsecondary text-base font-normal block focus:outline-none pb-2'
                                                        }
                                                        onClick={() => {
                                                            this.setState({ isTabChange: 'notes' });
                                                            this.isTabChange();
                                                        }}
                                                    >
                                                        {this.props.t('viewMemberNotes')}
                                                    </button>
                                                </nav>
                                                <div id="Tab_session_notes">
                                                    {this.state.isTabChange === 'studentHistory' ? (
                                                        <div
                                                            className="overflow-x-auto rounded-lg"
                                                            id="studentHistory"
                                                            role="tabpanel"
                                                            aria-labelledby="student-History"
                                                        >
                                                            <div className="overflow-x-auto rounded-lg bg-collaboratortable">
                                                                <table className="w-full table-bordered">
                                                                    <thead className="text-left text-white bg-borderline whitespace-nowrap ">
                                                                        <tr className="border-0 dashboard-table">
                                                                            <th className="p-2 font-semibold text-UIsecondary text-start">
                                                                                {this.props.t(
                                                                                    'sessionType'
                                                                                )}
                                                                            </th>
                                                                            <th className="p-2 font-semibold text-UIsecondary text-start">
                                                                                {this.props.t(
                                                                                    AppConfig.labels
                                                                                        .channelName
                                                                                )}
                                                                            </th>
                                                                            <th className="p-2 font-semibold text-UIsecondary text-start">
                                                                                {this.props.t(
                                                                                    'element'
                                                                                )}
                                                                            </th>
                                                                            {/* <th className="p-2 font-semibold text-UIsecondary text-start">
                                        Educator
                                      </th> */}
                                                                            <th className="p-2 font-semibold text-UIsecondary text-start">
                                                                                {this.props.t(
                                                                                    'sessionTime'
                                                                                )}
                                                                            </th>
                                                                            <th className="p-2 font-semibold text-center text-UIsecondary">
                                                                                {this.props.t(
                                                                                    'status'
                                                                                )}
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state
                                                                            .studentHistoryLoading ? (
                                                                            <tr>
                                                                                <td
                                                                                    colSpan="6"
                                                                                    className="items-center justify-center p-3"
                                                                                >
                                                                                    <Loader />
                                                                                </td>
                                                                            </tr>
                                                                        ) : (
                                                                            <>
                                                                                {this.state
                                                                                    .studentHistory &&
                                                                                this.state
                                                                                    .studentHistory
                                                                                    .length ===
                                                                                    0 ? (
                                                                                    <tr>
                                                                                        <td colSpan="6">
                                                                                            <div
                                                                                                style={{
                                                                                                    display:
                                                                                                        'flex',
                                                                                                    alignItems:
                                                                                                        'center',
                                                                                                    justifyContent:
                                                                                                        'center',
                                                                                                }}
                                                                                            >
                                                                                                <p
                                                                                                    style={{
                                                                                                        marginBottom:
                                                                                                            '0',
                                                                                                        color: 'white',
                                                                                                    }}
                                                                                                >
                                                                                                    {this.props.t(
                                                                                                        'noDatasFound'
                                                                                                    )}
                                                                                                </p>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                ) : (
                                                                                    this.state
                                                                                        .studentHistory &&
                                                                                    this.state.studentHistory.map(
                                                                                        (
                                                                                            data,
                                                                                            index
                                                                                        ) => (
                                                                                            <tr
                                                                                                className="break-word whitespace-nowrap bg-borderline"
                                                                                                key={
                                                                                                    index
                                                                                                }
                                                                                            >
                                                                                                <td className="p-3 text-collabotxt">
                                                                                                    {
                                                                                                        data.sessionType
                                                                                                    }
                                                                                                </td>
                                                                                                <td className="p-3 text-white">
                                                                                                    {data.subject
                                                                                                        ? data.subject
                                                                                                        : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                                                </td>
                                                                                                <td className="p-3 text-white">
                                                                                                    {data.subCategory
                                                                                                        ? data.subCategory
                                                                                                        : RESPONSE_CONSTANT.HYPHEN}
                                                                                                </td>
                                                                                                {/* <td
                                                  className="p-3 text-white table-ellipse"
                                                  title={data.educatorName}
                                                >
                                                  {data.educatorName}
                                                </td> */}
                                                                                                <td className="p-3 text-white">
                                                                                                    {' '}
                                                                                                    {moment(
                                                                                                        data.sessionTime
                                                                                                    )
                                                                                                        .locale(
                                                                                                            this
                                                                                                                .props
                                                                                                                .language ||
                                                                                                                AppConfig.appLanguage ||
                                                                                                                'en'
                                                                                                        )
                                                                                                        .format(
                                                                                                            'MMM DD, YYYY hh:mm A'
                                                                                                        )}
                                                                                                </td>
                                                                                                <td className="p-3 text-center text-white">
                                                                                                    <div
                                                                                                        style={{
                                                                                                            pointerEvents:
                                                                                                                'none',
                                                                                                        }}
                                                                                                    >
                                                                                                        <SessionStatusButton
                                                                                                            status={
                                                                                                                data.visitStatus
                                                                                                            }
                                                                                                            studentHistory={
                                                                                                                this
                                                                                                                    .props
                                                                                                                    .studentHistory
                                                                                                            }
                                                                                                            hideCursor={
                                                                                                                true
                                                                                                            }
                                                                                                        />
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    )
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                                <div className="flex items-center justify-end gap-2 mt-4 -space-x-px">
                                                                    {this.state.totalPages > 1 && (
                                                                        <Pagination
                                                                            currentPage={
                                                                                this.state
                                                                                    .currentPage
                                                                            }
                                                                            pageDisplayCount={
                                                                                this.state
                                                                                    .totalPages
                                                                            }
                                                                            onPageChange={
                                                                                this
                                                                                    .handlePageChange
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : this.state.isTabChange === 'notes' ? (
                                                        <div
                                                            className="overflow-x-auto rounded-lg"
                                                            id="notes"
                                                            role="tabpanel"
                                                            aria-labelledby="notes-tab"
                                                        >
                                                            <>
                                                                <div className="overflow-x-auto rounded-lg bg-collaboratortable">
                                                                    <table className="w-full table-bordered">
                                                                        <thead className="text-left text-primary bg-borderline whitespace-nowrap">
                                                                            <tr className="border-0 dashboard-table">
                                                                                <th className="p-2 font-semibold text-UIsecondary text-start">
                                                                                    {this.props.t(
                                                                                        'reportedBy'
                                                                                    )}
                                                                                </th>
                                                                                <th className="p-2 font-semibold text-UIsecondary text-start">
                                                                                    {this.props.t(
                                                                                        'timeOfNotesAdded'
                                                                                    )}
                                                                                </th>
                                                                                <th className="p-2 font-semibold text-UIsecondary text-start">
                                                                                    {this.props.t(
                                                                                        'comment'
                                                                                    )}
                                                                                </th>
                                                                                <th className="p-2 font-semibold text-UIsecondary text-start">
                                                                                    {this.props.t(
                                                                                        'attachment'
                                                                                    )}
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.state
                                                                                .addNotesLoading ? (
                                                                                <tr>
                                                                                    <td
                                                                                        colSpan="3"
                                                                                        className="items-center justify-center p-3"
                                                                                    >
                                                                                        <Loader />
                                                                                    </td>
                                                                                </tr>
                                                                            ) : (
                                                                                <>
                                                                                    {this.state
                                                                                        .addNotesHistory &&
                                                                                    this.state
                                                                                        .addNotesHistory
                                                                                        .length ===
                                                                                        0 ? (
                                                                                        <tr>
                                                                                            <td colSpan="3">
                                                                                                <div
                                                                                                    style={{
                                                                                                        display:
                                                                                                            'flex',
                                                                                                        alignItems:
                                                                                                            'center',
                                                                                                        justifyContent:
                                                                                                            'center',
                                                                                                    }}
                                                                                                >
                                                                                                    <p
                                                                                                        style={{
                                                                                                            marginBottom:
                                                                                                                '0',
                                                                                                            color: 'white',
                                                                                                        }}
                                                                                                    >
                                                                                                        {this.props.t(
                                                                                                            'noDatasFound'
                                                                                                        )}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ) : (
                                                                                        this.state
                                                                                            .addNotesHistory &&
                                                                                        this.state.addNotesHistory.map(
                                                                                            (
                                                                                                data,
                                                                                                index
                                                                                            ) => (
                                                                                                <tr
                                                                                                    className="break-word bg-borderline whitespace-nowrap"
                                                                                                    key={
                                                                                                        index
                                                                                                    }
                                                                                                >
                                                                                                    <td
                                                                                                        className="p-3 table-ellipse text-collabotxt"
                                                                                                        title={
                                                                                                            data.addedBy
                                                                                                        }
                                                                                                    >
                                                                                                        {
                                                                                                            data.addedBy
                                                                                                        }
                                                                                                    </td>
                                                                                                    <td className="p-3 text-white">
                                                                                                        {' '}
                                                                                                        {moment(
                                                                                                            data.createdAt
                                                                                                        )
                                                                                                            .locale(
                                                                                                                this
                                                                                                                    .props
                                                                                                                    .language ||
                                                                                                                    AppConfig.appLanguage ||
                                                                                                                    'en'
                                                                                                            )
                                                                                                            .format(
                                                                                                                'MMM DD, YYYY hh:mm A'
                                                                                                            )}
                                                                                                    </td>
                                                                                                    <td
                                                                                                        className="p-3 text-white"
                                                                                                        style={{
                                                                                                            whiteSpace:
                                                                                                                'normal',
                                                                                                        }}
                                                                                                    >
                                                                                                        {
                                                                                                            data.notes
                                                                                                        }
                                                                                                    </td>
                                                                                                    <td
                                                                                                        className="p-3 text-white"
                                                                                                        style={{
                                                                                                            whiteSpace:
                                                                                                                'normal',
                                                                                                            wordBreak:
                                                                                                                'break-all',
                                                                                                        }}
                                                                                                    >
                                                                                                        {data.materialImages &&
                                                                                                        data
                                                                                                            .materialImages
                                                                                                            .length ? (
                                                                                                            <div className="flex flex-row flex-wrap w-auto gap-3 mt-3 bg-transparent rounded-lg max-w-fit sm:mt-0 cursor">
                                                                                                                {data.materialImages.map(
                                                                                                                    (
                                                                                                                        res,
                                                                                                                        index
                                                                                                                    ) => {
                                                                                                                        return (
                                                                                                                            <div
                                                                                                                                key={
                                                                                                                                    index
                                                                                                                                }
                                                                                                                            >
                                                                                                                                {res?.fileType ===
                                                                                                                                'pdf' ? (
                                                                                                                                    <a
                                                                                                                                        href={
                                                                                                                                            res.image
                                                                                                                                        }
                                                                                                                                        target="_blank"
                                                                                                                                        rel="noopener noreferrer"
                                                                                                                                        onClick={(
                                                                                                                                            e
                                                                                                                                        ) => {
                                                                                                                                            e.preventDefault();
                                                                                                                                            const userId =
                                                                                                                                                store.get(
                                                                                                                                                    'bloomIfAI_id'
                                                                                                                                                );
                                                                                                                                            this.props.getUserById(
                                                                                                                                                userId,
                                                                                                                                                (
                                                                                                                                                    response
                                                                                                                                                ) => {
                                                                                                                                                    if (
                                                                                                                                                        response
                                                                                                                                                    ) {
                                                                                                                                                        window.open(
                                                                                                                                                            res.image,
                                                                                                                                                            '_blank'
                                                                                                                                                        );
                                                                                                                                                    } else {
                                                                                                                                                        console.error(
                                                                                                                                                            'Failed to fetch user details'
                                                                                                                                                        );
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                            );
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <i
                                                                                                                                            className="fa-solid fa-file-pdf"
                                                                                                                                            style={{
                                                                                                                                                backgroundColor:
                                                                                                                                                    '#ede8e8',
                                                                                                                                                color: '#c30909',
                                                                                                                                                width: '2rem',
                                                                                                                                                height: '2rem',
                                                                                                                                                borderRadius:
                                                                                                                                                    '0.25rem',
                                                                                                                                                fontSize:
                                                                                                                                                    '30px',
                                                                                                                                                display:
                                                                                                                                                    'flex',
                                                                                                                                                justifyContent:
                                                                                                                                                    'center',
                                                                                                                                                alignItems:
                                                                                                                                                    'center',
                                                                                                                                            }}
                                                                                                                                        ></i>
                                                                                                                                    </a>
                                                                                                                                ) : (
                                                                                                                                    <a
                                                                                                                                        href={
                                                                                                                                            res.image
                                                                                                                                        }
                                                                                                                                        target="_blank"
                                                                                                                                        rel="noopener noreferrer"
                                                                                                                                        onClick={(
                                                                                                                                            e
                                                                                                                                        ) => {
                                                                                                                                            e.preventDefault();
                                                                                                                                            const userId =
                                                                                                                                                store.get(
                                                                                                                                                    'bloomIfAI_id'
                                                                                                                                                );
                                                                                                                                            this.props.getUserById(
                                                                                                                                                userId,
                                                                                                                                                (
                                                                                                                                                    response
                                                                                                                                                ) => {
                                                                                                                                                    if (
                                                                                                                                                        response
                                                                                                                                                    ) {
                                                                                                                                                        window.open(
                                                                                                                                                            res.image,
                                                                                                                                                            '_blank'
                                                                                                                                                        );
                                                                                                                                                    } else {
                                                                                                                                                        console.error(
                                                                                                                                                            'Failed to fetch user details'
                                                                                                                                                        );
                                                                                                                                                    }
                                                                                                                                                }
                                                                                                                                            );
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <img
                                                                                                                                            src={
                                                                                                                                                res.image
                                                                                                                                            }
                                                                                                                                            className="w-8 h-8 rounded border-black-10"
                                                                                                                                            key={
                                                                                                                                                index
                                                                                                                                            }
                                                                                                                                            alt=""
                                                                                                                                        />
                                                                                                                                    </a>
                                                                                                                                )}
                                                                                                                            </div>
                                                                                                                        );
                                                                                                                    }
                                                                                                                )}
                                                                                                            </div>
                                                                                                        ) : (
                                                                                                            <span>
                                                                                                                {this.props.t(
                                                                                                                    'noMaterialImagesFound'
                                                                                                                )}
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            )
                                                                                        )
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                    <div className="flex items-center justify-end gap-2 mt-4 -space-x-px">
                                                                        <div className="student-profile">
                                                                            {this.state
                                                                                .addNotestotalPages >
                                                                                1 && (
                                                                                <Pagination
                                                                                    currentPage={
                                                                                        this.state
                                                                                            .addNotesCurrentPage
                                                                                    }
                                                                                    pageDisplayCount={
                                                                                        this.state
                                                                                            .addNotestotalPages
                                                                                    }
                                                                                    onPageChange={
                                                                                        this
                                                                                            .handleAddNotesPageChange
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {/* )} */}
                                                                </div>
                                                            </>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                </div>
                            )}
                        </div>
                    </main>
                </div>
                <AddNotes
                    {...this.state}
                    openModal={this.state.isAddNotesModalOpen}
                    closeAddNotesModal={this.closeAddNotesModal}
                    onChange={(event) => {
                        this.setState({
                            notesSummary: event.target.value,
                        });
                    }}
                    submitAddNotes={() => {
                        this.notesSubmitBtn();
                    }}
                    handleFileUpload={this.handleFileUpload}
                    removeImage={this.removeImage}
                    materialUploadedImages={this.state.materialUploadedImages}
                />
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getStudent: (id, callback) => {
            dispatch(getStudent(id, callback));
        },
        getStudentHistory: (educatorId, id, values, callback) => {
            dispatch(getStudentHistory(educatorId, id, values, callback));
        },
        submitAddNotes: (values, callback) => {
            dispatch(submitAddNotes(values, callback));
        },
        getAddNotesList: (id, values, callback) => {
            dispatch(getAddNotesList(id, values, callback));
        },
        showNotification: (values, callback) => {
            dispatch(showNotification(values, callback));
        },
        getUserById: (userId, callBack) => {
            dispatch(getUserById(userId, callBack));
        },
    };
};

const ConnectedStudentSummary = withLanguage(connect(null, mapDispatchToProps)(StudentSummary));

export default (props) => (
    <LanguageProvider>
        <ConnectedStudentSummary {...props} />
    </LanguageProvider>
);
